import { AllModules } from '@ag-grid-enterprise/all-modules';

export const defaultGridHeight = { height: '63vh' };
const HEADER_HEIGHT = 30;
const ROW_HEIGHT = 26;

export const initialGridData = {
	modules: AllModules,
	rowData: [],
	columnDefs: [],
	defaultColDef: [],
	pagination: true,
	paginationPageSize: 50,
	rowHeight: ROW_HEIGHT,
	headerHeight: HEADER_HEIGHT,
};

export const allOption = {
	id: '/All/',
	originalId: '/All/',
	name: 'All',
	title: 'All',
	expanded: false,
	parentId: '/',
	value: null,
	children: [],
};

export const renderL1Spend = {
	columnDefs: [
		{
			field: 'name',
			headerName: 'AP L1Category',
		},
		{ field: 'client', headerName: 'Client Benchmark' },
		{ field: 'median', headerName: 'Industry Benchmark' },
		{ field: 'min', headerName: 'Min' },
		{ field: 'max', headerName: 'Max' },
	],
	key: 'finalExportForSpendL1',
};

export const renderL2Spend = {
	columnDefs: [
		{
			field: 'l2category',
			headerName: 'AP L2Category',
		},
		{ field: 'client', headerName: 'Client Benchmark' },
		{ field: 'median', headerName: 'Industry Benchmark' },
		{ field: 'min', headerName: 'Min' },
		{ field: 'max', headerName: 'Max' },
	],
	key: 'finalExportForSpendL2',
};

export const renderL3Spend = {
	columnDefs: [
		{
			field: 'l3category',
			headerName: 'AP L3Category',
		},
		{ field: 'client', headerName: 'Client Benchmark' },
		{ field: 'median', headerName: 'Industry Benchmark' },
		{ field: 'min', headerName: 'Min' },
		{ field: 'max', headerName: 'Max' },
	],
	key: 'finalExportForSpendL3',
};

export const renderL1Revenue = {
	columnDefs: [
		{
			field: 'name',
			headerName: 'AP L1Category',
		},
		{ field: 'client', headerName: 'Client Benchmark' },
		{ field: 'median', headerName: 'Industry Benchmark' },
		{ field: 'min', headerName: 'Min' },
		{ field: 'max', headerName: 'Max' },
	],
	key: 'finalExportForRevenueL1',
};

export const renderL2Revenue = {
	columnDefs: [
		{
			field: 'l2category',
			headerName: 'AP L2Category',
		},
		{ field: 'client', headerName: 'Client Benchmark' },
		{ field: 'median', headerName: 'Industry Benchmark' },
		{ field: 'min', headerName: 'Min' },
		{ field: 'max', headerName: 'Max' },
	],
	key: 'finalExportForRevenueL2',
};

export const renderL3Revenue = {
	columnDefs: [
		{
			field: 'l3category',
			headerName: 'AP L3Category',
		},
		{ field: 'client', headerName: 'Client Benchmark' },
		{ field: 'median', headerName: 'Industry Benchmark' },
		{ field: 'min', headerName: 'Min' },
		{ field: 'max', headerName: 'Max' },
	],
	key: 'finalExportForRevenueL3',
};

//when L1 category is selected in sidebar
// export const renderL1Fragmented = {
// 	columnDefs: [
// 		{ headerName: 'AP L1Category', field: 'categoryName' },
// 		{ headerName: 'AP L4Category', field: 'AP_L4Category' },
// 		{ headerName: 'Vendor Count', field: 'vendorCount' },
// 		{
// 			headerName: 'Percentage',
// 			field: 'percentage',
// 			valueFormatter: params => {
// 				if (!isNaN(params.value)) {
// 					return formatPercentageToSingleDecimal(params.value);
// 				}
// 				return params.value;
// 			},
// 		},
// 		{ headerName: 'Total Spend', field: 'totalSpend' },
// 	],
// };

//when L2 category is selected in sidebar
// export const renderL2Fragmented = {
// 	columnDefs: [
// 		{ headerName: 'AP L2Category', field: 'categoryName' },
// 		{ headerName: 'AP L4Category', field: 'AP_L4Category' },
// 		{ headerName: 'Vendor Count', field: 'vendorCount' },
// 		{
// 			headerName: 'Percentage',
// 			field: 'percentage',
// 			valueFormatter: params => {
// 				if (!isNaN(params.value)) {
// 					return formatPercentageToSingleDecimal(params.value);
// 				}
// 				return params.value;
// 			},
// 		},
// 		{ headerName: 'Total Spend', field: 'totalSpend' },
// 	],
// };

//when L3 category is selected in sidebar
// export const renderL3Fragmented = {
// 	columnDefs: [
// 		{ headerName: 'AP L3Category', field: 'categoryName' },
// 		{ headerName: 'AP L4Category', field: 'AP_L4Category' },
// 		{ headerName: 'Vendor Count', field: 'vendorCount' },
// 		{
// 			headerName: 'Percentage',
// 			field: 'percentage',
// 			valueFormatter: params => {
// 				if (!isNaN(params.value)) {
// 					return formatPercentageToSingleDecimal(params.value);
// 				}
// 				return params.value;
// 			},
// 		},
// 		{ headerName: 'Total Spend', field: 'totalSpend' },
// 	],
// };

export const defaultColDefination = {
	flex: 1,
	minWidth: 100,
	resizable: true,
	sortable: true,
	filter: true,
};

export const renderTableForRevenue = value => {
	let columnDefs = [];
	let key = '';
	if (value === 0) {
		columnDefs = renderL1Revenue.columnDefs;
		key = renderL1Revenue.key;
	} else if (value === 1) {
		columnDefs = renderL2Revenue.columnDefs;
		key = renderL2Revenue.key;
	} else if (value === 2) {
		columnDefs = renderL3Revenue.columnDefs;
		key = renderL3Revenue.key;
	} else {
	}
	return { columnDefs, key };
};

export const renderTableForSpend = value => {
	let columnDefs = [];
	let key = '';
	if (value === 0) {
		columnDefs = renderL1Spend.columnDefs;
		key = renderL1Spend.key;
	} else if (value === 1) {
		columnDefs = renderL2Spend.columnDefs;
		key = renderL2Spend.key;
	} else if (value === 2) {
		columnDefs = renderL3Spend.columnDefs;
		key = renderL3Spend.key;
	} else {
	}
	return { columnDefs, key };
};

export const getColumnDefFragmentation = (value, taxonomyHeader) => {
	let columnDefs = [];
	if (value === 1) {
		// columnDefs = renderL1Fragmented.columnDefs;
		columnDefs = [
			{ headerName: `${taxonomyHeader} L1Category`, field: 'categoryName' },
			{
				headerName: `${taxonomyHeader} L4Category`,
				field: 'DynamicL4Category',
			},
			{ headerName: 'Vendor Count', field: 'vendorCount' },
			{
				headerName: 'Percentage',
				field: 'percentage',
				valueFormatter: params => {
					if (!isNaN(params.value)) {
						return formatPercentageToSingleDecimal(params.value);
					}
					return params.value;
				},
			},
			{ headerName: 'Total Spend', field: 'totalSpend' },
		];
	} else if (value === 2) {
		// columnDefs = renderL2Fragmented.columnDefs;
		columnDefs = [
			{ headerName: `${taxonomyHeader} L2Category`, field: 'categoryName' },
			{
				headerName: `${taxonomyHeader} L4Category`,
				field: 'DynamicL4Category',
			},
			{ headerName: 'Vendor Count', field: 'vendorCount' },
			{
				headerName: 'Percentage',
				field: 'percentage',
				valueFormatter: params => {
					if (!isNaN(params.value)) {
						return formatPercentageToSingleDecimal(params.value);
					}
					return params.value;
				},
			},
			{ headerName: 'Total Spend', field: 'totalSpend' },
		];
	} else if (value === 3) {
		// columnDefs = renderL3Fragmented.columnDefs;
		columnDefs = [
			{ headerName: `${taxonomyHeader} L3Category`, field: 'categoryName' },
			{
				headerName: `${taxonomyHeader} L4Category`,
				field: 'DynamicL4Category',
			},
			{ headerName: 'Vendor Count', field: 'vendorCount' },
			{
				headerName: 'Percentage',
				field: 'percentage',
				valueFormatter: params => {
					if (!isNaN(params.value)) {
						return formatPercentageToSingleDecimal(params.value);
					}
					return params.value;
				},
			},
			{ headerName: 'Total Spend', field: 'totalSpend' },
		];
	} else {
	}
	return columnDefs;
};

export const getMonthYearRange = input => {
	const monthNames = [
		'January',
		'February',
		'March',
		'April',
		'May',
		'June',
		'July',
		'August',
		'September',
		'October',
		'November',
		'December',
	];

	let currentMonth = input.currentMonth;
	let currentYear = input.currentYear;

	let nextMonth = currentMonth + 1;
	let nextYear = currentYear;
	let previousMonth = currentMonth - 1;
	let previousYear = currentYear;

	if (previousMonth === 0) {
		previousMonth = 12;
		previousYear--;
	}
	if (nextMonth > 12) {
		nextMonth = 1;
		nextYear++;
	}

	let currentMonthName = monthNames[currentMonth - 1];
	let nextMonthName = monthNames[nextMonth - 1];
	let previousMonthName = monthNames[previousMonth - 1];

	let formattedInput = `${currentMonthName} ${currentYear}`;
	let formattedNext = `${nextMonthName} ${nextYear}`;
	let formattedPrevious = `${previousMonthName} ${previousYear}`;
	return {
		current: formattedInput,
		next: formattedNext,
		previous: formattedPrevious,
	};
};

export const formatPercentageToSingleDecimal = value => {
	if (value === null) {
		return `0 %`;
	} else {
		return `${value.toFixed(1)} %`;
	}
};
